import { Component, Input, OnInit, SimpleChanges, OnChanges } from '@angular/core';
import {
  GroupOrder,
  GroupOrderService,
  MenuItemsLayout,
  Order,
  OrderService,
  PanelItem,
  SizePrice,
  UpsellType,
  OrderType,
  OrderableIngredient,
  ConfigService,
  StoreConfig,
} from 'ngx-web-api';
import { Subscription } from 'rxjs';

import { take } from 'rxjs/operators';
import { OrderingUtilsService } from 'app/core/services/ordering-utils.service';

@Component({
  selector: 'fts-size-price-button',
  templateUrl: './size-price-button.component.html',
  styleUrls: ['./size-price-button.component.scss'],
})
export class SizePriceButtonComponent implements OnInit, OnChanges {
  @Input()
  tabName: string;
  @Input()
  panelItem: PanelItem;
  @Input()
  sizePrice: SizePrice;
  @Input()
  quantity: number;
  @Input()
  menuItemsLayout: MenuItemsLayout;
  @Input()
  isUpsell: boolean;
  @Input()
  isSister: boolean;
  @Input()
  upfrontIngredient: OrderableIngredient;
  @Input()
  upfrontChoice: string;
  @Input()
  upsellType: UpsellType;
  @Input()
  upfrontQualifiers: string[];
  @Input()
  shouldDisplayNoticePeriodMessage: boolean = true;
  @Input()
  buttonWidthMode: 'max' | 'min' | undefined = undefined;
  formattedNoticePeriod: string = '';

  menuItemsLayoutEnum = MenuItemsLayout;
  isPanelItemFundraiserAndOrdered: boolean;
  auditName: string;
  menuFetchedWithoutOrderType = false;

  order: Order;
  loadingSubscription: Subscription;
  private groupOrder: GroupOrder;
  hasCateringNoticeTime: boolean;

  constructor(
    private orderService: OrderService,
    private groupOrderService: GroupOrderService,
    private orderingUtilsService: OrderingUtilsService,
    private configService: ConfigService
  ) {}

  ngOnInit(): void {
    this.orderService.order$.subscribe(order => ((this.order = order), this.calcIsPanelItemFundraiserAndOrdered()));
    this.orderService.order$.pipe(take(1)).subscribe(order => (this.menuFetchedWithoutOrderType = order.orderType === OrderType.Any));
    this.groupOrderService.groupOrder$.subscribe(g => (this.groupOrder = g));
    this.configService.storeConfig$.subscribe((config: StoreConfig) => (this.hasCateringNoticeTime = config?.hasCateringNoticeTime));
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['panelItem'] || changes['sizePrice']) {
      this.setAuditName();
      this.calcIsPanelItemFundraiserAndOrdered();

      if (changes['sizePrice']) {
        this.formattedNoticePeriod = this.orderingUtilsService.formatNoticePeriod(this.sizePrice?.noticePeriod);
      }
    }
  }

  addToOrder() {
    this.loadingSubscription = this.orderingUtilsService.addToOrder(
      this.groupOrder,
      this.panelItem,
      this.tabName,
      this.menuFetchedWithoutOrderType,
      this.sizePrice,
      this.menuItemsLayout,
      this.quantity,
      this.upfrontChoice,
      this.upfrontIngredient,
      this.upfrontQualifiers,
      this.isUpsell,
      this.upsellType,
      this.isSister,
      this.sizePrice?.noticePeriod
    );
  }

  calcIsPanelItemFundraiserAndOrdered() {
    this.isPanelItemFundraiserAndOrdered =
      this.panelItem.isFundraiser && this.order?.fundraisers?.some(fundraiser => fundraiser.name === this.panelItem.name);
  }

  setAuditName(): void {
    let size = '';
    if (this.sizePrice && this.sizePrice.size && this.sizePrice.size.toLowerCase() !== 'size') {
      size = `${this.sizePrice.size} `;
    }
    this.auditName = `Add "${size}${this.panelItem.name}" ${this.panelItem.type.toLowerCase()} to order`;
  }
}
